import cn from 'classnames'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import { ReactComponent as Billogram } from './logos/billogram.svg'
import { ReactComponent as Handelsbanken } from './logos/handelsbanken.svg'
import { ReactComponent as Klarna } from './logos/klarna.svg'
import { ReactComponent as PayPal } from './logos/paypal.svg'
import { ReactComponent as Seb } from './logos/seb.svg'
import { ReactComponent as Stripe } from './logos/stripe.svg'
import { ReactComponent as Swedbank } from './logos/swedbank.svg'
import Lansforsakringar from './logos/lansforsakringar.png'
import Nordea from './logos/nordea.png'
import Provider from './provider'

import styles from './providers.module.scss'

interface IProvidersProps {
  className?: string
  variant?: 'regular' | 'dark' | 'light'
}

const Providers = ({ className = '', variant = 'regular' }: IProvidersProps) => (
  <div className={cn(styles.root, variant === 'dark' && styles.dark, variant === 'light' && styles.light, className)}>
    <p className={styles.lede}>
      <FormattedMessage defaultMessage="Dooer funkar extra bra med" id="section.providers.lede" />
    </p>
    <div className={styles.inner}>
      <Provider logo={<Handelsbanken />} />
      <Provider logo={<Seb />} />
      <Provider logo={<Swedbank />} />
    </div>
    <div className={styles.inner}>
      <Provider logo={<Billogram />} />
      <Provider logo={<Klarna />} />
      <Provider logo={<Stripe />} />
    </div>
    <div className={styles.inner}>
      <Provider className={styles.nordea} img={Nordea} />
      <Provider logo={<PayPal />} />
      <Provider img={Lansforsakringar} />
    </div>
  </div>
)

export default Providers
